module.exports = __webpack_public_path__ + "static/15-035503cd6131314d3be2e0c1c79cb922.jpg";